import { register } from "timeago.js";
import esLocale from "timeago.js/lib/lang/es";

[ esLocale ].forEach(locale => {
    register('es', locale)
})
